import React, { useEffect } from 'react';
import { Trans } from 'react-i18next';
import { Text } from 'mintel-react-ui';

import PageWrapper from '../PageWrapper';
import { RecoverPasswordProps } from './RecoverPassword';
import useTranslation from '../translations';
import styles from './RecoverPassword.scss';
import { changeLanguage } from '../shared/utils';

export const EmailSentPage = ({
  fields,
  backLink,
  language = 'en',
}: RecoverPasswordProps): JSX.Element => {
  const { t } = useTranslation();
  useEffect(() => {
    changeLanguage(language);
  }, [language]);

  return (
    <PageWrapper>
      <div className={styles.root}>
        <div>
          <Text.Heading2>{t('Recover Password')}</Text.Heading2>
        </div>
        <div className={styles.description}>
          <Text.Body2>
            <Trans>
              An email has been sent to <b>{{ name: fields.email.value }}</b>.
              If the account exists, an email will be sent with further
              instructions.
            </Trans>
          </Text.Body2>
        </div>
        <div className={styles.backButton} data-testid="back">
          <Text.Body2>
            <a href={backLink}>{t('Back to login')}</a>
          </Text.Body2>
        </div>
      </div>
    </PageWrapper>
  );
};

export default EmailSentPage;
